<ng-container *ngIf="menu; else bareMinimum">
  <dxo-left-nav
    [dxoDataset]="{ selector: '.account-name,.menu-item.level-one > .section-header .sub-label', data: { pii: '' } }"
    logoImg="/assets/images/symetra_logo.svg"
    [logoLink]="LogoHref"
    [sideBarMenu]="menu"
    [topRightMenuItems]="topRightMenu"
    [topRightLabel]="userFullName"
    [appTagName]="Benefits"
  >
    <router-outlet></router-outlet>
  </dxo-left-nav>
</ng-container>
<ng-template #bareMinimum>
  <router-outlet></router-outlet>
  <dxo-left-nav-top-nav
    [topRightMenuItems]="topRightMenu"
    [topRightLabel]="userFullName"
    logoImg="/assets/images/symetra_logo.svg"
    class="fallback-nav"
  ></dxo-left-nav-top-nav>
</ng-template>
<app-portal-timeout-modal [countdownTimeSeconds]="initialCountdown" (logout)="logout()"></app-portal-timeout-modal>
<app-footer></app-footer>
